import type { SVGProps } from 'react';
const SvgReplyAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#reply_all_svg__a)">
      <path
        fill="currentColor"
        d="M7 8V5l-7 7 7 7v-3l-4-4 4-4Zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11Z"
      />
    </g>
    <defs>
      <clipPath id="reply_all_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReplyAll;
